import ApiError from "components/common/ApiError";
import LoaderComponent from "components/common/Loader";
import { API_ENDPOINTS } from "constants";
import { useFetchData } from "hooks/apiHooks";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Button, Card, CardBody, Col, Container, Row } from "reactstrap";

const AcceptInvitation = () => {
    console.log('AcceptInvitation')
    const { t } = useTranslation();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const token = searchParams.get("token")
    const tenantId = searchParams.get("tenant_id")
    const { data, error, isLoading, refetch } = useFetchData(API_ENDPOINTS.USERS.VALIDATE_INVITATION, null, true, {token: token, tenant_id: tenantId}, false);
    console.log('AcceptInvitation', data)
    useEffect(() => {
        if (data === 'success') {
            sessionStorage.clear(); 
            sessionStorage.setItem("invitationToken", JSON.stringify({ token, tenant_id: tenantId }));
            navigate('/login')
        } 
    }, [data, token, tenantId, navigate]);

    if (error) return (
        <Container fluid className="d-flex justify-content-center align-items-center vh-100 background-container">
            <Row className="w-100">
                <Col sm="6" md="6" lg="6" xl="6" className="mx-auto">
                    <ApiError retryFetch={refetch} errorMessage={t('login.errorToken')} />
                </Col>
            </Row>
        </Container>);
    if (isLoading || !data) return <LoaderComponent/>

    return (
        <Container fluid className="d-flex justify-content-center align-items-center vh-100 background-container">
            <Row className="w-100">
                <Col sm="6" md="6" lg="4" xl="3" className="mx-auto">
                    <Card>
                        <CardBody>
                            <h4 className="text-center mb-4">{t('login.invitationHeadline')}</h4>
                            <h4 className="text-center mb-4">{t('login.invitationSubline')}</h4>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default AcceptInvitation;
